export const m5l0Solution = `
//TODO: add a function to get this to compile
fn main() {
    call_me();
}

fn call_me() {
}

// do not modify code on this line or below

#[test]
fn test_compile() {
    assert(1 == 1, 'Surprising');
    main();
}`;
